import { forwardRef } from 'react';
import { Plus, Trash2 } from 'lucide-react';

interface FlowButtonAddFABProps {
  onClick: () => void;
  isDropTarget?: boolean;
  isHovering?: boolean;
}

const FlowButtonAddFAB = forwardRef<HTMLButtonElement, FlowButtonAddFABProps>(
  ({ onClick, isDropTarget, isHovering }, ref) => {
    return (
      <button
        ref={ref}
        onClick={isDropTarget ? undefined : onClick}
        className={`fixed bottom-4 left-4 flex items-center justify-center transition-all duration-300 ${
          isDropTarget
            ? isHovering
              ? 'z-50 w-16 h-16 rounded-2xl bg-red-500 text-white shadow-[0_0_30px_rgba(239,68,68,0.7)] scale-110'
              : 'z-50 w-14 h-14 rounded-xl bg-red-400/90 text-white shadow-[0_0_20px_rgba(239,68,68,0.5)] animate-bounce'
            : 'z-40 w-10 h-10 rounded-full bg-gray-600 hover:bg-gray-700 text-white shadow-lg hover:shadow-xl'
        }`}
        title={isDropTarget ? 'Drop to delete' : 'Add Flow Button'}
        style={isDropTarget ? { filter: `brightness(${isHovering ? 1.3 : 1.1})` } : undefined}
      >
        {isDropTarget ? (
          <Trash2 className={`transition-all duration-300 ${isHovering ? 'w-8 h-8' : 'w-6 h-6'}`} />
        ) : (
          <Plus className="w-5 h-5" />
        )}
      </button>
    );
  }
);

FlowButtonAddFAB.displayName = 'FlowButtonAddFAB';

export default FlowButtonAddFAB;
